(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Contexts whose images should never zoom: banners (already animate on load),
  // product/collection cards, header, footer, cart, and search UI.
  var EXCLUDE = [
    '.banner-zoom-media',
    '.banner-zoom-reveal',
    '.banner-zoom-target',
    '.scroll-reveal-group',
    '.card-wrapper',
    '.product-card',
    '.blog-card',
    'header',
    '.section-header',
    '.header-wrapper',
    'footer',
    '.footer',
    'cart-drawer',
    '.cart-drawer',
    '.cart-notification',
    '.drawer',
    'predictive-search',
    '.search-modal'
  ].join(',');

  // Skip decorative/utility imagery such as icons, logos and payment badges.
  var ICON_RE = /icon|logo|sprite|payment|badge|arrow|swatch|flag|star|rating/i;
  var MIN_SIZE = 120;

  function eligible(img) {
    if (img.closest(EXCLUDE)) return false;
    var hint = (img.className || '') + ' ' + (img.getAttribute('alt') || '') + ' ' + (img.currentSrc || img.src || '');
    if (ICON_RE.test(hint)) return false;
    var width = img.getBoundingClientRect().width || img.naturalWidth || parseInt(img.getAttribute('width') || '0', 10);
    if (width && width < MIN_SIZE) return false;
    return true;
  }

  function init() {
    var targets = Array.prototype.slice.call(document.querySelectorAll('img')).filter(eligible);
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (img) {
        img.classList.add('zoom-reveal', 'is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

    targets.forEach(function (img) {
      img.classList.add('zoom-reveal');
      observer.observe(img);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
